import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { Subject, Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';
import { LoginUsersService } from "src/app/Services/login-users.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { ProductsService } from "src/app/Services/product.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";

import { CheckoutService } from "../../../Services/checkout.service";
import { EmbryoService } from "../../../Services/Embryo.service";

@Component({
    selector: "HeaderTwo",
    templateUrl: "./HeaderTwo.component.html",
    styleUrls: ["./HeaderTwo.component.scss"],
})
export class HeaderTwoComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() Categories: any;
    @Input() lang: string = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : "en";
    @ViewChild("search", { static: true }) searchq!: ElementRef;
    @ViewChild("searchValueWeb") searchValueWeb: ElementRef | any;
    @ViewChild("searchValue") searchValue: ElementRef | any;
    completResults: any;
    completeResultsLoaded = false;
    searchInput: string = "";
    productList: any = [];
    search = "";
    showSearch: boolean = false;
    subscription!: Subscription;
    toggleLoading: boolean = false;
    unread_count: any;
    environmentVariables: any;
    showcards = true;
    filter = {
        q: "",
    };
    loadingAutoComplete = false;
    isMenuOpen = false;
    user: any;
    headerBackgroundColor: any;
    headerTextColor: any;
    showScrollButton2 = false;
    showTotalPriceMenu = false;
    changeIconFill: boolean = true;
    expandedSearchBar: boolean = false;
    generalStaticPages=[]
    private searchQuery: Subject<string> = new Subject();
    isScreenLessThan500px: boolean = window.innerWidth < 500;
    targetUrl: string = window.location.href;

    constructor(
        public embryoService: EmbryoService,
        public router: Router,
        public checkoutService: CheckoutService,
        public userLoginServies: LoginUsersService,
        private ProductsService: ProductsService,
        private confgServ: StaticPagesService,
        private renderer: Renderer2,
        public marketingService: MarketingService,
    ) {
        if (this.router.url.includes('?')) {
            this.targetUrl = localStorage.getItem('targetUrl') ?
                JSON.parse(JSON.stringify(localStorage.getItem('targetUrl'))) :
                this.router.url.split('?')[0];
        }
        else {
            this.targetUrl = this.router.url;
            localStorage.setItem('targetUrl', this.targetUrl);
        }

        this.confgServ.getAllStaticPages().subscribe((res:any)=>{
            this.generalStaticPages =  res.data.filter((x:any)=>x.flag == "GENERAL");
        })

        userLoginServies.getUserDataEmit().subscribe((user) => {
            this.user = user;
            if (
                this.user &&
                !this.user?.is_guest &&
                !this.user?.phone_verified &&
                this.environmentVariables?.VERIFY_AFTER_SIGNUP &&
                !this.router.url.includes("verify-phone")
            ) {
                this.router.navigate(["/" + this.lang + "/verify-phone/"]);
            }
            
            if (
                this.user &&
                !this.user?.is_guest &&
                this.user?.addresses?.length == 0 &&
                this.environmentVariables?.ADDRESS_AFTER_SIGNUP &&
                !this.router.url.includes("/add-address") &&
                !(
                    !this.user?.phone_verified &&
                    this.environmentVariables?.VERIFY_AFTER_SIGNUP
                )
            ) {
                this.router.navigate(["/" + this.lang + "/add-address"]);
            }

            if ((this.user?.is_guest &&
                this.environmentVariables?.FORCE_LOGIN_SIGNUP &&
                !this.router.url.includes("/session/sign-in")) || 
                (this.user?.is_guest  
                && this.environmentVariables?.ENABLE_ADMIN_APPROVAL 
                && this.environmentVariables?.CLIENT_APPROVAL_OPTIONS === "disable_products" ) 
            ) {
                this.router.url.includes('forgot-password')
                || this.router.url.includes('signup') 
                || this.router.url.includes('change-password')  
                || this.router.url.includes('terms-and-conditions')  
                || this.router.url.includes('privacy-policy')  
                || this.router.url.includes('cookie-policy')  
                || this.router.url.includes('pages/contact')
                || this.router.url.includes('pages/branches')
                || (this.environmentVariables.ENABLE_SHOW_FORMS_WITHOUT_SIGNUP &&
                    this.router.url.includes('forms'))
                || this.generalStaticPages.some((x:any) => this.router.url.includes(x.slug))
                    ? " " : this.router.navigate(["/" + this.lang + "/session/signin"], {
                        queryParams: {
                            returnUrl: this.targetUrl
                        }
                    });
            }
        });
        this.getInitilizingData();
        localStorage.setItem("blurredSearch", "false");
        window.dispatchEvent(new Event("resize"))
        window.addEventListener('resize', () => {
          this.isScreenLessThan500px = window.innerWidth < 500;
        });
        this.renderer.listen("window", "click", (e: Event) => {
            if (
                e.target === this.searchValueWeb?.nativeElement ||
                e.target === this.searchValue?.nativeElement
            ) {
                this.isMenuOpen = true;
            } else {
                this.isMenuOpen = false;
                if (this.searchInput == "") this.completResults = null;
            }
        });
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }
    ngAfterViewInit(): void {

     this.embryoService.isPaymentPage.subscribe(res=>{
     })
      
        setTimeout(() => {
            if (document.querySelector("#app-nav-list-menu")) {
                let menu = document.querySelector("#app-nav-list-menu");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton2 = true;
                    } else {
                        this.embryoService.showScrollButton2 = false;
                    }
                }
            } else if (document.querySelector("#app-nav-list-menu2")) {
                let menu = document.querySelector("#app-nav-list-menu2");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton2 = true;
                    } else {
                        this.embryoService.showScrollButton2 = false;
                    }
                }
            }
        }, 4000);
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.headerBackgroundColor =
                this.environmentVariables.HEADER_BACKGROUND_COLOR;
            this.headerTextColor = this.environmentVariables.HEADER_TEXT_COLOR;
        });
    }
    openAreaPopup() {
        this.user["show_area_input"] = true;
        this.userLoginServies.setUserDataEmit(this.user);
    }
    openBranchPopup() {
        this.user["show_branch_input"] = true;
        this.userLoginServies.setUserDataEmit(this.user);
    }
    @HostListener("window:scroll", ["$event"])
    onScrollEvent($event: any) {
        if ($event.target.documentElement.scrollTop > 0) {
            this.showcards = false;
        } else if (
            !this.router.url.includes("/en/") &&
            !this.router.url.includes("/ar/")
        ) {
            this.showcards = true;
        }
        if ($event.target.documentElement.scrollTop < 10) {
            setTimeout(() => {
                let menu = document.getElementById("app-nav-list-menu")
                    ? document.getElementById("app-nav-list-menu")
                    : document.getElementById("app-nav-list-menu2");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton2 = true;
                    } else {
                        this.embryoService.showScrollButton2 = false;
                    }
                }
            }, 100);
        }
        if ($event.target.documentElement.scrollTop > 10) {
            setTimeout(() => {
                let menu = document.getElementById("app-nav-list-menu2")
                    ? document.getElementById("app-nav-list-menu2")
                    : document.getElementById("app-nav-list-menu");
                if (menu) {
                    let hasHorizontalScrollbar =
                        menu.scrollWidth > menu.clientWidth;
                    if (hasHorizontalScrollbar) {
                        this.embryoService.showScrollButton2 = true;
                    } else {
                        this.embryoService.showScrollButton2 = false;
                    }
                }
            }, 100);
        }
    }
    ngOnInit() {
        if (
            this.router.url.includes("/en/") ||
            this.router.url.includes("/ar/")
        ) {
            this.showcards = false;
        } else {
            this.showcards = true;
        }
        this.searchQuery
            .pipe(debounceTime(1000))
            .subscribe((searchTextValue) => {
                this.filter.q = searchTextValue;
                this.handleSearch(this.filter);
            });
        this.embryoService.productCartSub.subscribe((res) => {
            if (res?.items) {
                this.productList = res?.items;
            } else {
                this.productList = res;
            }
        });

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                if (
                    this.router.url.includes("/en/") ||
                    this.router.url.includes("/ar/")
                ) {
                    this.showcards = false;
                } else {
                    this.showcards = true;
                }
                this.searchInput = "";
                this.isMenuOpen = false;
                this.removeSearchQuery();
                if (
                    this.user &&
                    !this.user?.is_guest &&
                    !this.user?.phone_verified &&
                    this.environmentVariables?.VERIFY_AFTER_SIGNUP &&
                    !this.router.url.includes("verify-phone")
                ) {
                    this.router.navigate(["/" + this.lang + "/verify-phone/"]);
                }
                if (
                    this.user &&
                    !this.user?.is_guest &&
                    this.user?.addresses?.length == 0 &&
                    this.environmentVariables?.ADDRESS_AFTER_SIGNUP &&
                    !this.router.url.includes("/add-address") &&
                    !(
                        !this.user?.phone_verified &&
                        this.environmentVariables?.VERIFY_AFTER_SIGNUP
                    )
                ) {
                    this.router.navigate(["/" + this.lang + "/add-address"]);
                }

                if (
                    this.user?.is_guest &&
                    this.environmentVariables?.FORCE_LOGIN_SIGNUP &&
                    !this.router.url.includes("/session/sign-in") 
                )
                {
                    this.router.url.includes('forgot-password')
                    || this.router.url.includes('signup') 
                    || this.router.url.includes('change-password')  
                    || this.router.url.includes('terms-and-conditions')  
                    || this.router.url.includes('privacy-policy')  
                    || this.router.url.includes('cookie-policy')
                    || this.router.url.includes('pages/contact')
                    || this.router.url.includes('pages/branches')
                    || (this.environmentVariables.ENABLE_SHOW_FORMS_WITHOUT_SIGNUP &&
                        this.router.url.includes('forms'))
                    || this.generalStaticPages.some((x:any) => this.router.url.includes(x.slug))
                        ? " " :
                        this.router.navigate(["/" + this.lang + "/session/signin"], {
                            queryParams: {
                                returnUrl: this.targetUrl
                            }
                        });
                }

            }
        
        });
    }
    removeSearchQuery() {
        this.searchInput = "";
        this.completResults = null;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    searchInProducts(event: any) {
        const blurred = event.type === "blur";
        //event.target.blur();
        localStorage.setItem("blurredSearch", blurred.toString());
        if (event.type === "change") {
            setTimeout(() => {
                const isBlurred = localStorage.getItem("blurredSearch");
                if (isBlurred == "false" && event.target.value) {
                    this.router.navigate(["/" + this.lang + "/products"], 
                    {
                        queryParams: { search: event.target.value },
                    });
                }
            }, 300);
        } else if (event.type === "keyup" && event.target.value) {
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: { search: event.target.value },
            });
            if (event.key && event.key === "Enter") {
                event.target.blur();
            }
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        }
    }

    searchInProductsMobile(val: any) {
        if (val.value) {
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: { search: val.value },
            });
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        }
    }
    showProductPage(product: any) {
        this.completResults = [];
        const nameRouting = product.name_en.replace(/\s/g, "-");
        const parentId = product.parent_id || product.id;
        this.router.navigate(
            ["/" + this.lang + "/", product.slug],
            // {
            //     state: { name: nameRouting },
            //     queryParams: { variant: product.id },
            // }
        );
    }

    toggleSearch() {
        this.showSearch = !this.showSearch;
        setTimeout(() => {
            document.getElementById("inputSearchMobile")?.focus();
            if (this.showSearch) this.isMenuOpen = true;
        }, 100);
    }
    autoCompleteSearch(ev: any, val: any) {
        if (ev.key && val) {
            if (ev.key == "Enter") {
                this.completResults = [];
                this.searchInProducts(ev);
            } else {
                this.searchQuery.next(val);
            }
        }
    }
    moreProductsClick() {
        this.completResults = null;
        this.router.navigate(["/" + this.lang + "/products"], {
            queryParams: { search: this.filter.q },
        });
    }

    handleSearch(filterParams: any) {
        this.loadingAutoComplete = true;
        this.completeResultsLoaded = false;

        this.subscription = this.ProductsService.getProductsSearch(
            filterParams,
            ""
        ).subscribe((res: any) => {
            this.loadingAutoComplete = false;
            this.completeResultsLoaded = true;
            this.completResults = res.data.products;
        });
    }
    toggleSidebar() {
        this.embryoService.sidenavOpen = !this.embryoService.sidenavOpen;
    }

    openConfirmationPopup(value: any) {
        let message;
        if (this.lang === "en") {
            message = "Are you sure you want to remove this product?";
        } else {
            message = "هل تريد إزالة المنتج من السلة ؟";
        }
        this.embryoService.confirmationPopup(message).subscribe((res) => {
            if (res == "yes") {
                this.getPopupResponse(res, value.product, "cart", value.index);
            }
        });
    }

    getPopupResponse(response: any, product: any, type: any, index?: number) {
        if (response) {
            if (type === "cart") {
                if (this.userLoginServies.isGuest()) {
                    if (product.in_stock && product.amount <= product.stock) {
                        const cartProduct = {
                            reset: false,
                            items: [{ id: product.id, amount: 0 }],
                        };
                        this.checkoutService
                            .addOrUpdateToCart(cartProduct)
                            .subscribe((rep: any) => {
                                if (rep.code === 200) {
                                    Swal.fire({
                                        html: `<p style='color:white'>${
                                            this.lang === "en"
                                                ? "Product removed from cart"
                                                : "تم ازالة المنتج السلة"
                                        }</p>`,
                                        width: 250,
                                        position: "bottom-end",
                                        background: "#51A351",
                                        timerProgressBar: true,
                                        showConfirmButton: false,
                                        timer: 3000,
                                        backdrop: false,
                                        allowOutsideClick: true,
                                    });
                                    this.embryoService.productCartSub.next(
                                        rep.data
                                    );
                                }
                            });
                    } else if (product.available_soon) {
                        Swal.fire({
                            html: `<p style='color:white'>${
                                this.lang === "en"
                                    ? "Ops This product is available soon"
                                    : "  هذا سيتوفر قريبا"
                            }</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    } else {
                        Swal.fire({
                            html: `<p style='color:white'>${
                                this.lang === "en"
                                    ? "Ops This product is out of stock"
                                    : "نفد هذا المنتج من المخازن"
                            }</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                } else {
                    this.embryoService.removeFromCart(product, index);
                }
            }
        }
    }

    addAllWishlistToCart(values: any) {
        this.embryoService.addAllWishListToCart(values);
    }

    selectedCurrency(value: any) {
        this.embryoService.currency = value;
    }

    addToCart(value: any) {
        this.embryoService.addToCartGuest(value);
    }

    slide() {
        // const buttonRight = document.getElementById('app-nav-list-menu');
        // buttonRight!.onclick =  () =>{
        if (this.lang == "en") {
            document.getElementById("app-nav-list-menu")!.scrollLeft += 500;
            document.getElementById("app-nav-list-menu2")!.scrollLeft += 500;
        } else {
            document.getElementById("app-nav-list-menu")!.scrollLeft -= 500;
            document.getElementById("app-nav-list-menu2")!.scrollLeft -= 500;
        }
        // };
    }
    slideFlibed() {
        // const buttonRight = document.getElementById('app-nav-list-menu');
        // buttonRight!.onclick =  () =>{
        if (this.lang == "ar") {
            document.getElementById("app-nav-list-menu")!.scrollLeft += 500;
            document.getElementById("app-nav-list-menu2")!.scrollLeft += 500;
        } else {
            document.getElementById("app-nav-list-menu")!.scrollLeft -= 500;
            document.getElementById("app-nav-list-menu2")!.scrollLeft -= 500;
        }
        // };
    }

    navigateToLink(link: any, mainCategory?: any, levelOneItem?: any) {
        if (link.includes("sub_category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "SubCategoryMenu", {
                name: params.sub_category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                description: params.sub_category_id,
            });
        } else if (link.includes("category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "CategoryMenu", {
                name: params.category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                description: params.category_id,
            });
        }

        if (link.includes("http") || link.includes("www")) {
            window.open(link, "_blank");
        } else if (link == "/") {
            this.router.navigate(["/"]);
        } else {
            let path = link.split("?");
            let path2 = mainCategory ? mainCategory.split("?") : [];
            var queryParams = this.getLinkQueryParams(path[1]);
            var queryParams2 = mainCategory
                ? this.getLinkQueryParams(path2[1])
                : {};
            if (mainCategory && queryParams2.category_id) {
                queryParams["category_id"] = queryParams2.category_id;
            }

            if (queryParams.category_id && !queryParams.group_id) {
                this.handleCategoryRouting(queryParams);
            }
            if (queryParams.group_id) {
                this.handleGroupRouting(queryParams);
            } else {
                if (
                    !queryParams["category_id"] &&
                    !queryParams["sub_category_id"] &&
                    !queryParams["group_id"]
                ) {
                    this.router.navigateByUrl(this.lang + link);
                }
            }
        }
    }

    getParams(url: any) {
        var params = { pair: [""] };
        var parser = document.createElement("a");
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            params.pair[0] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    getLinkQueryParams(params: any = "") {
        let paramsArray = params.split("&");
        let paramsArrayWithValues: any[] = [];
        paramsArray.forEach((element: any) => {
            paramsArrayWithValues.push(element.split("="));
        });
        let queryParams: any = {};
        paramsArrayWithValues.forEach((element: any) => {
            queryParams[element[0]] = element[1];
        });
        return queryParams;
    }

    handleCategoryRouting(queryParams: any) {
        if (
            !this.environmentVariables?.ENABLE_CATEGORY_VIEW ||
            queryParams.sub_category_id
        ) {
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            this.router.navigate(["/" + this.lang + "/category"], {
                queryParams: queryParams,
            });
        }
    }

    handleGroupRouting(queryParams: any) {
        if (!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW) {
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            this.router.navigate(["/" + this.lang + "/category"], {
                queryParams: queryParams,
            });
        }
    }


        public toggleRightSidenav() {
        this.embryoService.paymentSidenavOpen =
            !this.embryoService.paymentSidenavOpen;
        this.sendNewFreeDeliveryStatusData(this.embryoService.promoObject);
    }


     sendNewFreeDeliveryStatusData(data: any) {
        this.embryoService.sendFreeDeliveryStatus(data);
    }

       total: number = 0;
    subTotal: number = 0;
        flattenedProductList :any =[]
    productlistcopyed:any;
    promoObject:any
   public getTotalPrice() {
        let total = 0;
        this.total = 0;
           this.flattenedProductList =[]
       if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
           this.productList.forEach((subArray: any) => {
           if (subArray && subArray.items) {
            this.flattenedProductList.push(...subArray.items);
            }
         });
       this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        if (this.productlistcopyed && this.productlistcopyed.length) {
            for (const product of this.productlistcopyed) {
                product.discount_price !== null
                    ? (total += product.discount_price)
                    : (total += product.price);
            }
            this.total = total;
                     if (this.embryoService.promoObject) {
                total = this.embryoService.promoObject.free_delivery
                    ? total
                    : this.embryoService.promoObject.amount -
                      total +
                      (total + this.embryoService.deliveryFees);
            } else {
                total += this.embryoService.deliveryFees
                    ? this.embryoService.deliveryFees
                    : 0;
            }
          }
        return total;
    }
    
    expandSearchBar(){
        this.expandedSearchBar = !this.expandedSearchBar;
    }
  }
